/* eslint-disable import/no-extraneous-dependencies */
import cryptoJs from 'crypto-js';

export const encryptData = (data) => {
  const {
    REACT_APP_SECRET_KEY,
  } = process.env;
  const ciphertext = cryptoJs.AES.encrypt(data, REACT_APP_SECRET_KEY).toString();
  return ciphertext;
};

export const decryptData = (data) => {
  try {
    const {
      REACT_APP_SECRET_KEY,
    } = process.env;
    const bytes = cryptoJs.AES.decrypt(data, REACT_APP_SECRET_KEY);
    const originalText = bytes.toString(cryptoJs.enc.Utf8);
    return originalText;
  } catch (e) {
    return null;
  }
};
